
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/virtual-address",
      function () {
        return require("private-next-pages/virtual-address.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/virtual-address"])
      });
    }
  